module.exports = __webpack_public_path__ + "static/img/3.63e534e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/1/3.png
// module id = H6UQ
// module chunks = 0